<qrcode [qrdata]="qrCodeUrl" [width]="width" [margin]="margin" [errorCorrectionLevel]="errorCorrectionLevel"></qrcode>
